const lang = {
  component: {
    ChatbotPopup: {
      pTagFirst: `Hallo, ich bin Alma.`,
      pTagSecond: `Ich wurde erschaffen, um Ihre Fragen zum`,
      pTagThird: `Wachstum von Kindern`,
      pTagFourth: `zu beantworten. Wie kann ich Ihnen helfen?`,
      button: {
        copy: `Alma fragen`,
        label: `Eine Frage stellen`
      }
    },
    Chatbot: {
      promptBtnLabel: `Einen Chat mit Alma beginnen`,
      disclaimer: `Die Informationen, die Sie uns mitteilen, helfen uns, nützliche Antworten zu geben. Für weitere Informationen lesen Sie bitte unsere`,
      privacyPolicy: `Datenschutzerklärung.`,
      submitBtnTxt: `Abschicken`
    }
  }
};

export default lang;
